<template>
    <b-modal
        ref="modal"
        size="xl"
        centered
        lazy
        hide-footer
        :title="list.title"
        @hidden="$emit('closed')"
    >
        <ConcernElements
            :product="product"
            :included-substances="includedSubstances"
            :excluded-substances="excludedSubstances"
            :legislations="legislationIds"
            :allowed-list-ids="allowedListIds"
            :company-has-information="true"
            :show-information-owner-settings="false"
            :show-instruction="false"
            :show-questions="showQuestions"
            :show-no-single-parts-checkbox="showNoSinglePartsCheckbox"
            :disable-automatic-question-state-inference="disableAutomaticQuestionStateInference"
            :auto-expand-lists="false"
            :auto-expand-list-when-only-one="true"
            :auto-expand-substances="false"
            container-class="p-0"
            @include="(substance, listIds) => $emit('include', substance, listIds)"
            @exclude="$emit('exclude', $event)"
            @undefined="$emit('undefined', $event)"
            @listQuestionStateUpdated="(list, state) => $emit('question-state-updated', list, state)"
        />
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import { ConcernElements } from '@/views/product/components/product-card'

export default {
    name: 'SubstanceListSelectorModal',
    components: { BModal, ConcernElements },
    props: {
        list: { type: Object, required: true },
        legislations: { type: Array, required: true },
        product: { type: Object, required: true },
        includedSubstances: { type: Array, default: () => [] },
        excludedSubstances: { type: Array, default: () => [] },
        allowedListIds: { type: Array, default: null },
        showQuestions: { type: Boolean, default: true },
        showNoSinglePartsCheckbox: { type: Boolean, default: true },
        disableAutomaticQuestionStateInference: { type: Boolean, default: false },
    },
    computed: {
        legislationIds() {
            return this.legislations.map(legislation => legislation.id)
        },
    },
    methods: {
        show() {
            this.$refs.modal.show()
        },
    },
}
</script>
